import { render } from "./header.vue?vue&type=template&id=445df0f8&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=445df0f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-445df0f8"

export default script